import React from "react";

export const ArrowUpRightIcon: React.FC<IconProps> = ({
  size = 20,
  color = "white",
  ...props
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M4.49967 16.666L3.33301 15.4993L12.9997 5.83268H7.49967V4.16602H15.833V12.4993H14.1663V6.99935L4.49967 16.666Z"
      fill={color}
    />
  </svg>
);
